import axios, { AxiosError, AxiosResponse } from "axios";

const apiUrl = "/api/metabase";
const axiosClient = axios.create({
  baseURL: `${apiUrl}`,
  timeout: 0,
  headers: {
    "x-api-key": "mb_IqhfWjyr0ApBuOYEUtdwAtlnSl3ww/3fguu9kjZbJy0=",
    "Content-Type": "application/json",
  },
});

const availableServicesEndpoint = "/api/dashboard/8/dashcard/87/card/76/query";
const digitalServicesEndpoint = "/api/dashboard/8/dashcard/88/card/77/query";
const citizensRegisteredEndpoint = "/api/dashboard/8/dashcard/89/card/78/query";

export type Indicators = {
  availableServices: number;
  digitalServices: number;
  citizensRegistered: number;
};

type MetabaseResponse = {
  data: {
    rows: Array<Array<number>>;
  };
};

export async function getInidicators(
  codIbgeMunicipio?: number
): Promise<Indicators> {
  const payload = codIbgeMunicipio
    ? { cod_ibge_municipio: codIbgeMunicipio }
    : {};

  const [
    availableServicesResponse,
    digitalServicesResponse,
    citizensRegisteredResponse,
  ] = await Promise.all([
    axiosClient.post<
      MetabaseResponse,
      AxiosResponse<MetabaseResponse, AxiosError>,
      {}
    >(availableServicesEndpoint, payload),
    axiosClient.post<
      MetabaseResponse,
      AxiosResponse<MetabaseResponse, AxiosError>,
      {}
    >(digitalServicesEndpoint, payload),
    axiosClient.post<
      MetabaseResponse,
      AxiosResponse<MetabaseResponse, AxiosError>,
      {}
    >(citizensRegisteredEndpoint, payload),
  ]);

  return {
    availableServices: availableServicesResponse.data.data.rows[0][0],
    digitalServices: digitalServicesResponse.data.data.rows[0][0],
    citizensRegistered: citizensRegisteredResponse.data.data.rows[0][0],
  };
}
